import Button from "../ui/Button";
import Container from "../ui/Container";

function ProductSignal({ label, detail, className = "" }) {
  return (
    <div
      className={`absolute rounded-xl border border-border/80 bg-background/78 px-3 py-2 shadow-2xl shadow-black/20 backdrop-blur-md transition-all duration-200 ease-in-out ${className}`}
    >
      <p className="text-xs font-medium text-primary">{label}</p>
      <p className="mt-0.5 text-xs text-muted">{detail}</p>
    </div>
  );
}

function HeroVisual() {
  return (
    <div className="relative mx-auto mt-12 h-[320px] w-full max-w-[560px] overflow-hidden rounded-2xl border border-border/80 bg-surface/20 md:mt-0">
      <div className="hero-grid absolute inset-0 animate-pulse-grid" />
      <div className="absolute left-1/2 top-1/2 h-44 w-44 -translate-x-1/2 -translate-y-1/2 rounded-full bg-accent/22 blur-3xl" />
      <div className="absolute left-1/2 top-1/2 h-28 w-28 -translate-x-1/2 -translate-y-1/2 rounded-full border border-accent/40 bg-background/60 shadow-[0_0_80px_rgb(var(--color-accent)/0.34)]" />
      <div className="absolute left-1/2 top-1/2 h-16 w-16 -translate-x-1/2 -translate-y-1/2 rounded-2xl border border-border bg-surface/90 p-3 shadow-2xl shadow-black/25">
        <div className="h-full w-full rounded-xl bg-gradient-to-br from-accentSoft to-accent" />
      </div>

      <ProductSignal label="GradeVIT" detail="Live" className="left-5 top-8 animate-float-y" />
      <ProductSignal label="AI Utilities" detail="Research" className="right-5 top-20 animate-float-y [animation-delay:1.2s]" />
      <ProductSignal label="Mobile Apps" detail="Building" className="bottom-8 left-8 animate-float-y [animation-delay:2s]" />
      <ProductSignal label="SaaS Tools" detail="Planned" className="bottom-14 right-6 animate-float-y [animation-delay:3.1s]" />

      <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-background to-transparent" />
    </div>
  );
}

function HeroSection({ onNavigate }) {
  return (
    <section className="overflow-hidden pb-16 pt-16 sm:pb-20 sm:pt-20 lg:pb-24">
      <Container className="grid items-center gap-12 md:grid-cols-[1fr_0.86fr]">
        <div>
          <p className="mb-5 text-xs font-medium uppercase tracking-[0.18em] text-accent">
            Independent technology studio
          </p>
          <h1 className="max-w-3xl text-4xl font-semibold tracking-normal text-primary sm:text-5xl lg:text-6xl">
            Building products that solve real problems.
          </h1>
          <p className="mt-6 max-w-2xl text-base leading-7 text-secondary sm:text-lg">
            Technie is an independent technology studio creating tools, platforms, and applications for
            students, professionals, and everyday users.
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Button onClick={() => onNavigate("/products")}>Explore Products</Button>
            <Button variant="secondary" onClick={() => onNavigate("#blog")}>
              Read Blog
            </Button>
          </div>
        </div>
        <HeroVisual />
      </Container>
    </section>
  );
}

export default HeroSection;
